import interactionRepository from '@/repository/interactionRepository';
import interactions from '@/common/interactions';

const indexes = {
    billing: "billing",
    payment: "payment",
    method: "method",
    success: "ok",
    error: "er",
}
const state = {
    interaction: {
        billing: null,
        payment: null,
        method: null, // interaction method
        success: null,
        error: null,
        meth: null, // payment method [webpay, servipag, etc] meth is short for method
        sendInvoiceEmailSuccess: null,
        sendInvoiceEmailError: null,
        initialSuccess: null
    }
}
const actions = {
    async insertBillingInteraction({ commit, state }) {
        if (state.interaction.billing === null) {
            const channel = state.billingInfo.paymentChannel;
            const rut = state.billingInfo.customerIdentificationNumber;
            const num = interactions[channel][indexes.billing]
            await interactionRepository.createContact(num, rut);
            commit("billingInteraction", num);
        }
    },
    async insertPaymentInteraction({ commit, state }) {
        if (state.interaction.payment === null) {
            const paymentMetadata = state.billingInfo.metadata;
            const channel = state.billingInfo.paymentChannel;
            const rut = state.billingInfo.customerIdentificationNumber;
            let accountType = "pt"; // "pagar todo"
            let num = interactions[channel][accountType][indexes.payment]; // by default "pay all"

            if (!paymentMetadata.payAll &&
                paymentMetadata.productDescription != null &&
                !paymentMetadata.totalOverdue) {
                /**
                 * Only if pay by account
                 * One element selected not overdue
                 */
                if (state.selectedBillingAccountsElements.length === 1) {

                    if (state.selectedBillingAccountsElements[0].type === "HOGAR") {
                        accountType = "hvig"; // "hogar vigente"
                        num = interactions[channel][accountType][indexes.payment];
                    } else if (state.selectedBillingAccountsElements[0].type === "MOVIL") {
                        accountType = "mvig"; // "movil vigente"
                        num = interactions[channel][accountType][indexes.payment];
                    } else if (state.selectedBillingAccountsElements[0].type === "PUF") {
                        accountType = "pvig"; // "puf vigente"
                        num = interactions[channel][accountType][indexes.payment];
                    }
                }

            }
            if (!paymentMetadata.payAll &&
                paymentMetadata.productDescription != null &&
                paymentMetadata.totalOverdue) {
                /**
                 * Only if pay by account
                 * One element selected overdue
                 */
                if (state.selectedBillingAccountsElements.length === 1) {
                    if (state.selectedBillingAccountsElements[0].type === "HOGAR") {
                        accountType = "hven"; // "hogar vencida"
                        num = interactions[channel][accountType][indexes.payment];
                    } else if (state.selectedBillingAccountsElements[0].type === "MOVIL") {
                        accountType = "mven"; // "movil vencida"
                        num = interactions[channel][accountType][indexes.payment];
                    } else if (state.selectedBillingAccountsElements[0].type === "PUF") {
                        accountType = "pven"; // "puf vencida"
                        num = interactions[channel][accountType][indexes.payment];
                    }
                }
            }

            await interactionRepository.createContact(num, rut);
            commit("paymentInteraction", { interaction: num, account: accountType });
        }
    },
    async insertMethodInteraction({ commit, state }, meth) {
        if (state.interaction.method === null) {
            const type = state.interaction.type;
            const channel = state.billingInfo.paymentChannel;
            const rut = state.billingInfo.customerIdentificationNumber;
            let num = interactions[channel][type][meth][indexes.method];

            await interactionRepository.createContact(num, rut);
            commit("methodInteraction", { interaction: num, meth: meth });
        }
    },
    async insertSuccessInteraction({ commit, state }) {
        if (state.interaction.success === null) {
            const type = state.interaction.type;
            const meth = state.interaction.meth;
            const channel = state.billingInfo.paymentChannel;
            const rut = state.billingInfo.customerIdentificationNumber;
            let num = interactions[channel][type][meth][indexes.success];

            await interactionRepository.createContact(num, rut);
            commit("successInteraction", num);
        }
    },
    async insertErrorInteraction({ commit, state }) {
        if (state.interaction.error === null) {
            const type = state.interaction.type;
            const meth = state.interaction.meth;
            const channel = state.billingInfo.paymentChannel;
            const rut = state.billingInfo.customerIdentificationNumber;
            let num = interactions[channel][type][meth][indexes.error];

            await interactionRepository.createContact(num, rut);
            commit("errorInteraction", num);
        }
    },
    async insertSuccessSendInvoiceEmailInteraction({ commit, state }) {
        if (state.interaction.sendInvoiceEmailSuccess === null) {
            const channel = state.billingInfo.paymentChannel;
            const type = "sendInvoiceEmail";
            let num = interactions[channel][type][indexes.success];
            const rut = state.billingInfo.customerIdentificationNumber;

            await interactionRepository.createContact(num, rut);
            commit("successInteraction", num);
        }
    },
    async insertSuccessInitialInteraction({ commit, state }, { rut }) {
        if (state.interaction.initialSuccess === null) {
            const channel = "vtr_com";
            const type = "initial";
            let num = interactions[channel][type];

            await interactionRepository.createContact(num, rut);
            commit("successInteraction", num);
        }
    },
    async clickBannerInteraction({ commit, state }, { rut }) {
        if (state.interaction.initialSuccess === null) {
            const num = "1952";
            await interactionRepository.createContact(num, rut);
            commit("successInteraction", num);
        }
    },
    async insertErrorSendInvoiceEmailInteraction({ commit, state }) {
        if (state.interaction.sendInvoiceEmailError === null) {
            const channel = state.billingInfo.paymentChannel;
            const type = "sendInvoiceEmail";
            let num = interactions[channel][type][indexes.error];
            const rut = state.billingInfo.customerIdentificationNumber;

            await interactionRepository.createContact(num, rut);
            commit("errorInteraction", num);
        }
    },
    async insertModalHboInteraction({ commit, state }, { rut }) {
        if (state.interaction.initialSuccess === null) {
            const idInteractionCanal = "2";
            const observacion = "";
            await interactionRepository.insertInteraction(idInteractionCanal, rut, observacion);
            commit("successInteraction", idInteractionCanal);
        }
    },
    async interaccionModales({ commit, state }, { rut, codInter }) {
        if (state.interaction.initialSuccess === null) {
            const idInteractionCanal = codInter;
            const observacion = "";
            await interactionRepository.insertInteraction(idInteractionCanal, rut, observacion);
            commit("successInteraction", idInteractionCanal);
        }
    },
    async insertInteractionEnterToInvoice({ commit, state }, { rut }) {
        if (state.interaction.initialSuccess === null) {
            const idInteractionCanal = "228";
            const observacion = "";
            await interactionRepository.insertInteraction(idInteractionCanal, rut, observacion);
            commit("successInteraction", idInteractionCanal);
        }
    },
    async insertEmailEnvioComprobanteInteraction({ commit, state }, { rut, email }) {
        if (state.interaction.initialSuccess === null) {
            const idInteractionCanal = "4";
            const observacion = email;
            await interactionRepository.insertInteraction(idInteractionCanal, rut, observacion);
            commit("successInteraction", idInteractionCanal);
        }
    },


}
const getters = {}
const mutations = {
    billingInteraction(state, interaction) {
        state.interaction.billing = null;
        state.interaction.billing = interaction;
    },
    paymentInteraction(state, { interaction, account }) {
        state.interaction.payment = null;
        state.interaction.type = null;
        state.interaction.payment = interaction;
        state.interaction.type = account;
    },
    methodInteraction(state, { interaction, meth }) {
        state.interaction.method = null;
        state.interaction.meth = null;
        state.interaction.method = interaction;
        state.interaction.meth = meth;
    },
    sendInvoiceEmailSuccessInteraction(state, interaction) {
        state.interaction.sendInvoiceEmailSuccess = null;
        state.interaction.sendInvoiceEmailSuccess = interaction;
    },
    sendInvoiceEmailErrorInteraction(state, interaction) {
        state.interaction.sendInvoiceEmailError = null;
        state.interaction.sendInvoiceEmailError = interaction;
    },
    successInteraction(state, interaction) {
        state.interaction.success = null;
        state.interaction.success = interaction;
    },
    errorInteraction(state, interaction) {
        state.interaction.error = null;
        state.interaction.error = interaction;
    },
    resetInteractionState(currentState) {
        const s = state;
        Object.keys(s).forEach(key => {
            currentState[key] = s[key]
        })
    }
}

export {
    state,
    actions,
    getters,
    mutations
}